import { Separator } from "@/components/ui/separator";
import { ChatHistoryList } from "../components/Chat/ChatHistory";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

export default function Home() {
  return (
    <div className="container mx-auto mt-40">
      <h3 className="text-left font-mono mt-12 text-5xl flex items-center justify-between gap-3">
        Your Apps
        <Button variant="outline" className="text-primary">
          <Link to="/app/chat">New App</Link>
        </Button>
      </h3>
      <Separator className="my-12" />
      <div className="flex flex-wrap items-center gap-3 mt-12">
        <ChatHistoryList />
      </div>
    </div>
  );
}
